import { Link } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const SubMenuItem = styled(Link)`
  transition: color 0.3s linear;
  display: flex;
  white-space: nowrap;
  align-items: center;
  height: 36px;
  padding: 8px;

  &:hover,
  &.active {
    text-decoration: none;
    background: #bbbfc72b;
    border-radius: 8px;
  }


`;
